import { render, staticRenderFns } from "./VoteField.vue?vue&type=template&id=4ea64d83&"
import script from "./VoteField.vue?vue&type=script&lang=ts&"
export * from "./VoteField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports